// ES6 module syntax
import localizationEN from "l10n/app_en.json";
import localizationFR from "l10n/app_fr.json";
import LocalizedStrings from "react-localization";

export const AppLocalizations = new LocalizedStrings({
  en: localizationEN,
  fr: localizationFR,
});
